import React, {Component, Fragment} from 'react';
import {Button, Input} from 'reactstrap';
import ReactTable from 'react-table';
import UserForm from './UserForm.js';

class AdminTable extends Component {
	constructor(props) {
		super(props);

		this.renderEditable = this.renderEditable.bind(this);
	}


	renderEditable(cellInfo) {
		switch (this.props.subsection) {
		case 'INSTALLATION_TYPES':
			switch (cellInfo.column.Header) {
			case 'Hide C':
			case 'Hide P': {
				let usefulValue =
              this.props.data[cellInfo.index][cellInfo.column.id] === '1';
				return (
					<label className="switch table-switch">
						<div className="switchText">
							<div className="switchLft">Yes</div>
							<div className="switchRt">No</div>
						</div>
						<input
							type="checkbox"
							checked={usefulValue}
							id={`${cellInfo.column.id}`}
							onChange={(event) => {
								event.preventDefault();
								let newValue = '1';
								if (usefulValue) {
									newValue = '0';
								}
								this.props.handleAdminValueChange(
									this.props.data[cellInfo.index].ID,
									cellInfo.column.id,
									newValue
								);
							}}
						/>
						<span className="slider" />
					</label>
				);
			}
			default:
				return (
					<Input
						id={`${cellInfo.column.id}`}
						className="rounded-0 table-input"
						type="text"
						onChange={(event) => {
							event.preventDefault();
							this.props.handleAdminValueChange(
								this.props.data[cellInfo.index].ID,
								cellInfo.column.id,
								event.target.value
							);
						}}
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
					/>
				);
			}

		case 'MODELS':
			switch (cellInfo.column.Header) {
			case 'Visible':
			case 'Svc Quote Visible':
			case 'No Ext Warranty': {
				let usefulValue =
              this.props.data[cellInfo.index][cellInfo.column.id] === '1';
				return (
					<label className="switch table-switch">
						<div className="switchText">
							<div className="switchLft">Yes</div>
							<div className="switchRt">No</div>
						</div>
						<input
							type="checkbox"
							checked={usefulValue}
							id={`${cellInfo.column.id}`}
							onChange={(event) => {
								event.preventDefault();
								let newValue = '1';
								if (usefulValue) {
									newValue = '0';
								}
								this.props.handleAdminValueChange(
									this.props.data[cellInfo.index].ID,
									cellInfo.column.id,
									newValue
								);
							}}
						/>
						<span className="slider" />
					</label>
				);
			}
			default:
				return (
					<Input
						id={`${cellInfo.column.id}`}
						className="rounded-0 table-input"
						type="text"
						onChange={(event) => {
							event.preventDefault();
							this.props.handleAdminValueChange(
								this.props.data[cellInfo.index].ID,
								cellInfo.column.id,
								event.target.value
							);
						}}
						value={this.props.data[cellInfo.index][cellInfo.column.id]}
					/>
				);
			}
		case 'WARRANTY_TYPES':
			if (cellInfo.column.Header === 'Fee') {
				let usefulValue =
            this.props.data[cellInfo.index][cellInfo.column.id] === '1';
				return (
					<label className="switch table-switch">
						<div className="switchText">
							<div className="switchLft">Yes</div>
							<div className="switchRt">No</div>
						</div>
						<input
							type="checkbox"
							checked={usefulValue}
							id={`${cellInfo.column.id}`}
							onChange={(event) => {
								event.preventDefault();
								let newValue = '1';
								if (usefulValue) {
									newValue = '0';
								}
								this.props.handleAdminValueChange(
									this.props.data[cellInfo.index].ID,
									cellInfo.column.id,
									newValue
								);
							}}
						/>
						<span className="slider" />
					</label>
				);
			}
			return (
				<Input
					id={`${cellInfo.column.id}`}
					className="rounded-0 table-input"
					type="text"
					onChange={(event) => {
						event.preventDefault();
						this.props.handleAdminValueChange(
							this.props.data[cellInfo.index].ID,
							cellInfo.column.id,
							event.target.value
						);
					}}
					value={this.props.data[cellInfo.index][cellInfo.column.id]}
				/>
			);
		case 'USERS':
			switch (cellInfo.column.Header) {
			case 'Edit': {
				let btn = (
					<Button color="success" onClick={() => {
						return this.props.showUserModal(this.props.data[cellInfo.index]);
					}}>Edit</Button>
				);
				return btn;
			}

			// case 'Delete': {
			// 	let btn = (
			// 		<Button color="warning" onClick={() => {
			// 			// let submission = JSON.stringify(this.props.data[cellInfo.index]);
			// 			let data = this.props.data[cellInfo.index];
			// 			let deleteCmd = true;
			// 			return this.props.submitUserEdit(data, data, deleteCmd);
			// 		}}>Delete</Button>
			// 	);
			// 	return btn;
			// }

			case 'Reset': {
				let btn = (
					<Button color="info" onClick={() => {
						console.log(this.props.data[cellInfo.index].email);
						return this.props.forgotPasswordRequest(this.props.data[cellInfo.index].email);
					}}>Reset Password</Button>
				);
				return btn;
			}

			case 'Properties - Numbers & Commas ONLY!': {
				let metadata = this.props.data[cellInfo.index][cellInfo.column.id];
				if (metadata && metadata.properties) {
					let properties = metadata.properties;
					let propertiesString = properties.join(', ');
					return propertiesString;
				}
				return 'An error has occurred formating this cell';

			}
			case 'Username': {
				let metadata = this.props.data[cellInfo.index][cellInfo.column.id];
				if (metadata && metadata.usernames) {
					let usernameArray = metadata.usernames;
					let usernameString = usernameArray.join(', ');
					return usernameString;
				}
				return 'An error has occurred formating this cell';
			}
			case 'Permission Group': {
				let metadata = this.props.data[cellInfo.index][cellInfo.column.id];
				if (metadata && metadata.permissionGroup) {
					let displayPermissionGroup = metadata.permissionGroup.name;
					return displayPermissionGroup;
				}

				return 'An error has occurred formating this cell';
			}
			default:
				return (
					<Input
						id={`${cellInfo.column.id}`}
						className="rounded-0 table-input"
						type="text"
						onChange={(event) => {

							// TODO CHANGE:
							// 	event.preventDefault();
							// 	this.props.handleUserValueChange(
							// 		this.props.data[cellInfo.index].id,
							// 		cellInfo.column.id,
							// 		event.target.value
							// 	);

						}}

						value={this.props.data[cellInfo.index][cellInfo.column.id]}
					/>
				);
			}

		default:
			return (
				<Input
					id={`${cellInfo.column.id}`}
					className="rounded-0 table-input"
					type="text"
					onChange={(event) => {
						event.preventDefault();
						this.props.handleAdminValueChange(
							this.props.data[cellInfo.index].ID,
							cellInfo.column.id,
							event.target.value
						);
					}}
					value={this.props.data[cellInfo.index][cellInfo.column.id]}
				/>
			);
		}
	}

	render() {
		let betterColumns = this.props.columns.map((column) => {
			column.Cell = this.renderEditable;
			return column;
		});

		let userModal = '';

		if (this.props.showUserForm) {
			userModal = (
				<UserForm
					allProperties={this.props.propNums}
					forgotPasswordRequest={this.props.forgotPasswordRequest}
					hideUserModal={this.props.hideUserModal}
					permissionGroups={this.props.permissionGroups}
					showUserForm={this.props.showUserForm}
					submitUserEdit={this.props.submitUserEdit}
					themeName={this.props.themeName}
					userFormData={this.props.userFormData}
				/>
			);
		}

		/* if (this.props.subsection === 'USERS') { */
		/* return ( */
		/* <ReactTable */
		/* defaultPageSize={this.props.defaultPageSize} */
		/* data={this.props.data} */
		/* columns={betterColumns} */
		/* defaultSorted={[ */
		/* { */
		/* id:   'ID', */
		/* desc: true */
		/* } */
		/* ]} */
		/* /> */
		/* ); */
		/* } */


		return (
			<Fragment>
				<ReactTable
					defaultPageSize={this.props.defaultPageSize}
					data={this.props.data}
					columns={betterColumns}
					defaultSorted={[
						{
							id:   'ID',
							desc: true
						}
					]}
				/>
			</Fragment>
		);
	}
}

export default AdminTable;



// WEBPACK FOOTER //
// ./src/components/AdminTable.js